import "./App.css";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import { Toaster } from "react-hot-toast";
// import { ToastContainer } from "react-toastify";
import HomeLayout from "./Components/HomeLayout";
import Jobs from "./Pages/Jobs";
import MyJobs from "./Pages/MyJobs";
import Home from "./Pages/Home";
import JobDetails from "./Pages/JobDetails";
import CandidateRegister from "./Pages/CandiateRegister.js";
import CandidateProfile from "./Pages/CandidateProfile.js";
import ForgetPassword from "./Pages/CandidateLogin/ForgetPassword.js";
import CandidaetVideo from "./Pages/CandidateProfileDetails/CandidateVideo.js";
import CandidateVideoPlayer from "./Pages/CandidateProfileDetails/CandidateVideoPlayer.js";
import CandidateDouments from "./Pages/CandidateDouments.js";
import ConfirmPassword from "./Pages/CandidateLogin/ConfirmPassword.js";
import Login from "./Pages/CandidateLogin/Login.js";
import EmployeeProfile from "./Pages/EmployeeProfile.js";
import LoginWithOtp from "./Pages/CandidateLogin/LoginWithOtp.js";
import ProfileConfrmation from "./Pages/CandiateRegister.js/ProfileConfirmation.js";
import ListResumeTemplates from "./Pages/ResumeBuilder/ListResumeTemplate.js";
import Preview from "./Pages/Assesments/Preview.jsx";
import ViewAssessment from "./Pages/ViewAssessment.js";
import PaymentStatus from "./Pages/Assesments/PaymentStatus.jsx";
import CheckoutPage from "./Pages/Assesments/CheckoutPage.jsx";
import PreviewPersonality from "./Pages/Assesments/PreviewPersonality.jsx";
import HireHubTalent from "./Pages/HireHubTalent.jsx";
import HireHubRolePicker from "./Pages/HireHubRolePicker.jsx";

function App() {
  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: <HomeLayout />,
        children: [
          {
            index: true,
            element: <Home />,
          },
          {
            path: "jobs",
            element: <Jobs />,
          },
          {
            path: "myJobs",
            element: <MyJobs />,
          },
          {
            path: "jobDetails/:jobId",
            element: <JobDetails />,
          },
          {
            path: "signup/:candidateId?",
            element: <CandidateRegister />,
          },
          {
            path: "profile",
            element: <CandidateProfile />,
          },
          {
            path: "forgetPassword",
            element: <ForgetPassword />,
          },
          {
            path: "videoRecording/:videoId",
            element: <CandidaetVideo />,
          },
          {
            path: "videoPlayer",
            element: <CandidateVideoPlayer />,
          },
          {
            path: "documents/:jobId",
            element: <CandidateDouments />,
          },
          {
            path: "confirmpassword/:status/:code/:token",
            element: <ConfirmPassword />,
          },
          {
            path: "login",
            element: <Login />,
          },
          {
            path: "/otp",
            element: <LoginWithOtp />,
          },
          {
            path: "employeeProfile/:jobId",
            element: <EmployeeProfile />,
          },
          {
            path: "profileConfirmation",
            element: <ProfileConfrmation />,
          },
          {
            path: "resume-templates/:candidateId/:userId",
            element: <ListResumeTemplates />,
          },
          {
            path: "viewAssessment",
            element: <ViewAssessment />,
          },
          {
            path: "preview-assesment/:id",
            element: <Preview />,
          },
          {
            path: "preview-big5/:id",
            element: <PreviewPersonality />,
          },
          {
            path: "payment-assesment-status",
            element: <PaymentStatus />,
          },
          {
            path: "payment-checkout",
            element: <CheckoutPage />,
          },
          {
            path: "hirehub-talent",
            element: <HireHubTalent />,
          },
          {
            path: "hirehub-role-picker",
            element: <HireHubRolePicker />,
          },
        ],
      },
    ],
    { basename: "/" }
  );
  return (
    <>
      <RouterProvider
        router={router}
        // fallbackElement={<BigSpinner />}
      />
      <Toaster position="top-center" reverseOrder={false} />
      {/* <ToastContainer /> */}
    </>
  );
}

export default App;
